import {RichText, RichTextTextStyle} from '@gongxigames/framework/core/fragments/display';

const maxProbabilityTextConfig: Partial<RichTextTextStyle> = {
    fontFamily: 'PF DinDisplay Pro',
    fontSize: 50,
    fill: '0xd1d1d1',
    fontWeight: 'bold',
    align: 'right'
};

RichText.setStyle('maxProbabilityDesktop', {
    ...maxProbabilityTextConfig,
    fontSize: 41,
    verticalAlign: 'bottom'
});
RichText.setStyle('maxProbabilityLandscape', {
    ...maxProbabilityTextConfig
});
RichText.setStyle('maxProbabilityPortrait', {
    ...maxProbabilityTextConfig,
    align: 'center'
});
RichText.setStyle('RTPWatermarkDesktop', {
    ...maxProbabilityTextConfig,
    fontSize: 41,
    align: 'center'
});
RichText.setStyle('RTPWatermarkLandscape', {
    ...maxProbabilityTextConfig,
    fontSize: 40
});
RichText.setStyle('RTPWatermarkPortrait', {
    ...maxProbabilityTextConfig
});